import React from "react";

const AtIconMyRug = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      fill="none"
      viewBox="0 0 122 124"
    >
      <path
        fill="#F05223"
        stroke="#fff"
        d="M115.222 66.792h5.64v22.214a33.935 33.935 0 0 1-9.995 24.038A34.178 34.178 0 0 1 86.743 123H1a28.055 28.055 0 0 1 8.26-19.873 28.255 28.255 0 0 1 19.943-8.231h57.816c3.118 0 5.64-2.52 5.64-5.62a22.443 22.443 0 0 1 6.609-15.899 22.603 22.603 0 0 1 15.954-6.585ZM6.641 57.142 1 57.132l.055-22.21a33.9 33.9 0 0 1 2.627-13.005 33.992 33.992 0 0 1 7.42-11.013A34.127 34.127 0 0 1 22.19 3.559 34.223 34.223 0 0 1 35.25 1l85.75.21a28.02 28.02 0 0 1-2.173 10.75 28.08 28.08 0 0 1-6.136 9.105 28.212 28.212 0 0 1-9.166 6.07 28.289 28.289 0 0 1-10.8 2.113L34.91 29.11a5.65 5.65 0 0 0-3.99 1.636 5.61 5.61 0 0 0-1.662 3.968 22.415 22.415 0 0 1-1.738 8.6 22.48 22.48 0 0 1-4.91 7.282 22.568 22.568 0 0 1-7.331 4.856 22.632 22.632 0 0 1-8.638 1.69Z"
      />
    </svg>
  );
};

export default AtIconMyRug;
